import { render, staticRenderFns } from "./handout-printable.vue?vue&type=template&id=9d5063b8&"
import script from "./handout-printable.vue?vue&type=script&lang=js&"
export * from "./handout-printable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports